export const FETCH_CUIDADORES = "urgencia.fetch_cuidadores";
